export const ROOT = "/";
export const ACCESS_DENIED_PATH = "/access-denied";
export const ACCESS_HOME_PATH = "/home"
export const ACCESS_TERMSOFSERVICE_PATH="/terms"

// pages
